import { ApplicationState } from '@my-medication/bff-interfaces-ui/shared/applicationState';
import { useAdminStore } from '@store/adminStore';

const userStateBridge = {
  setUser: (payload: Partial<ApplicationState>): void => useAdminStore.getState().setUser(payload as ApplicationState),

  clearUser: (): void => useAdminStore.getState().clearUser(),

  isAuthenticated: (): boolean => useAdminStore.getState().user.id != null,

  setImpersonated: (payload: { timeout: number } | null): void => useAdminStore.getState().setImpersonated(payload),

  setLoggedInUntil: (payload: { timeout: number } | null): void => useAdminStore.getState().setLoggedInUntil(payload),

  setLocale: (locale: string): void => useAdminStore.getState().setLocale(locale),

  setSessionReady: (ready: boolean): void => useAdminStore.getState().setSessionReady(ready),

  setSessionInvalid: (invalid: boolean): void => useAdminStore.getState().setSessionInvalid(invalid),

  isSessionReady: (): boolean => useAdminStore.getState().user.sessionReady,
};

export { userStateBridge };
